import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import ChatHistory from './components/ChatHistory';
import Banner from './pages/Banner';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    return token ? children : <Navigate to="/login" />;
};

const App = () => {
    return (
        <Router>
            <div>
                <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<Banner />} />
                    <Route path="/login" element={<Login />} />
                    
                    {/* Protected routes */}
                    <Route path="/home" element={
                        <PrivateRoute>
                            <Home />
                        </PrivateRoute>
                    } />
                    <Route path="/chat-history" element={
                        <PrivateRoute>
                            <ChatHistory />
                        </PrivateRoute>
                    } />
                </Routes>
            </div>
            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                draggable
                pauseOnFocusLoss
            />
        </Router>
    );
};

export default App;